import { useQuery } from '@apollo/client';
import {
  createStyles,
  List,
  ListItem,
  makeStyles,
  Theme
} from '@material-ui/core';
import React from 'react';
import { useRecoilValue } from 'recoil';
import { TABLE_TYPES } from '../constants';
import { GetTablesQueryDocument } from '../services/graphql/typed-operations';
import { gastronomyState } from '../store/gastronomy';
import CircularIndeterminate from './CircularIndeterminate';
import OrderTypeDisabledUntilSwitch from './OrderTypeDisabledUntilSwitch';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    lineItem: {
      padding: theme.spacing(3)
    }
  })
);

const OrderTypeSettingsList: React.FC = () => {
  const classes = useStyles();
  const gastronomy = useRecoilValue(gastronomyState);
  const tableTypes =
    (gastronomy && gastronomy.options.tableTypes) || TABLE_TYPES;

  const { data, loading } = useQuery(GetTablesQueryDocument, {
    variables: {
      params: {
        user_uuid: gastronomy ? gastronomy.uuid : 'not set',
        status: 'ALL'
      }
    },
    skip: !gastronomy
  });

  return (
    <>
      {loading ? (
        <CircularIndeterminate />
      ) : (
        <List>
          {data &&
            tableTypes.map((t, i) => (
              <ListItem
                key={i}
                divider={i < tableTypes.length - 1}
                className={classes.lineItem}
              >
                <OrderTypeDisabledUntilSwitch
                  tableType={t}
                  tables={data.getTables}
                />
              </ListItem>
            ))}
        </List>
      )}
    </>
  );
};

export default OrderTypeSettingsList;
